import React, { ReactElement } from 'react';
import './style.css';

export type TooltipPropsType = {
  label?: string | ReactElement;
};

const Tooltip = (props: TooltipPropsType) => {
  const {
    label
  } = props;

  return <div id="tooltip" className="on top-left">
    <div className="tooltip-arrow" />
    <div className="tooltip-inner">{label ? label : 'ToolTip text goes here'}</div>
  </div>;
};

export default Tooltip;